import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  Tooltip,
  PointElement,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { LoanYearsSelect } from "../../Utils/CustomComponent";
import { useDispatch, useSelector } from "react-redux";
import { fetchLoanNumber } from "../../store/reducers/submitALoanSlice/api";
import { useAbortController } from "../../hooks/useAbortController";

ChartJS.register(
  CategoryScale,
  LinearScale,
  LineElement,
  Tooltip,
  PointElement
);

const finalLabel = [
  { title: "Jan", field: 1 },
  { title: "Feb", field: 2 },
  { title: "Mar", field: 3 },
  { title: "Apr", field: 4 },
  { title: "May", field: 5 },
  { title: "Jun", field: 6 },
  { title: "Jul", field: 7 },
  { title: "Aug", field: 8 },
  { title: "Sep", field: 9 },
  { title: "Oct", field: 10 },
  { title: "Nov", field: 11 },
  { title: "Dec", field: 12 },
];

const QuickBarChartLoanNumbers = () => {
  const { signal } = useAbortController();
  const dispatch = useDispatch();
  const [loanYearSelect, setLoanYearSelect] = useState([]);
  const loanNumberStatus = useSelector(
    (state) => state.submitALoan.loanNumbers.status
  );
  const loanValue = useSelector(
    (state) => state.submitALoan.loanNumbers.loanValue
  );
  const loanYears = useSelector(
    (state) => state.submitALoan.loanNumbers.loanYears
  );
  const lenderId = useSelector((state) => state.account.lenderId);
  useEffect(() => {
    dispatch(fetchLoanNumber({ lenderId, signal }));
  }, [dispatch, lenderId]);
  useEffect(() => {
    setLoanYearSelect(loanYears[0]);
  }, [loanYears]);

  const labels = finalLabel?.map((label) => label.title);
  const barData = {
    labels,
    datasets: [
      {
        data: loanValue[loanYearSelect],
        borderColor: "#438FFE",
        backgroundColor: "rgba(0,0,0,0.1)",
      },
    ],
  };
  const options = {
    responsive: true,
    plugins: {
      legend: false,
    },
    scales: {
      y: {
        title: {
          display: true,
          text: "Number of Loans",
        },
        grid: {
          display: false,
        },
      },
      x: {
        title: {
          display: true,
          text: `Year ${loanYearSelect}`,
        },
        grid: {
          display: true,
        },
      },
    },
  };
  return (
    <>
      {loanNumberStatus === "fulfilled" ? (
        <>
          <div className="d-flex justify-content-between flex-row">
            <h5>Number of Loans</h5>
            <LoanYearsSelect
              loanYears={loanYears}
              loanYearSelect={loanYearSelect}
              setLoanYearSelect={setLoanYearSelect}
            />
          </div>
          <div className="">
            <Line options={options} data={barData} />
          </div>
        </>
      ) : null}
    </>
  );
};
export default QuickBarChartLoanNumbers;
